import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { DataService } from '../../../../services/data.service';
import { VendorStatement } from '../../../../models/VendorStatement';
import { NgForm } from '@angular/forms';
import { ConfirmationPageSuccessComponent } from '../../../../shared-components/confirmation-page-success/confirmation-page-success.component';
import { ConfirmationPageFailComponent } from '../../../../shared-components/confirmation-page-fail/confirmation-page-fail.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { BusyIndicatorComponent } from '../../../../shared-components/busy-indicator/busy-indicator.component';
import { VendorService } from '../../../../services/vendor.service';

@Component({
  selector: 'app-vendor-statement',
  templateUrl: './vendor-statement.component.html',
  styleUrls: ['./vendor-statement.component.scss']
})
export class VendorStatementComponent implements OnInit, OnDestroy {
  vendorStmt: VendorStatement = new VendorStatement();
  gpVID = '';
  currency = '';
  errorMsg: string;
  successMsg: string;
  showFailConfirmation: boolean;
  showSuccessConfirmation: boolean;
  reader: FileReader = new FileReader();
  filename: string;
  fileData: Uint8Array;
  isFileInvalid: boolean;
  isAmtValid: boolean;
  fileInputErrorMsg: string;
  alive = true;
  @ViewChild('fileInput') fileInput: any;
  @ViewChild('txtAmt') txtAmt: ElementRef;
  constructor(private dataSvc: DataService,
    private vendorSvc: VendorService,
    private spinner: NgxSpinnerService) {
    this.currency = dataSvc.userDisplayInfo.Currency;
    this.gpVID = dataSvc.userDisplayInfo.GPVID;
  }

  ngOnInit() {
  }
  onlyDecimalNumberKey(event) {
    let charCode = (event.which) ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31
        && (charCode < 48 || charCode > 57))
        return false;
    return true;
}
  sanitizeAmount(amt: string, frm: NgForm) {
    if (amt) {
      let newAmt = amt.replace(',', '');
      newAmt = newAmt.replace('$', '');

      if (newAmt !== '') {
        const ldAmt = parseFloat(newAmt);
        if (ldAmt <= 0.0) {
          frm.controls['vendorStmt.TotalAmount'].setErrors({'incorrect' : true});
        } else {
          frm.controls['vendorStmt.TotalAmount'].setErrors(null);
          this.txtAmt.nativeElement.value = ldAmt.toFixed(2);
        }
      } else {
        this.txtAmt.nativeElement.value = newAmt;
      }
    }
  }

  onSubmit() {

    this.vendorStmt.Currency = this.currency;
    this.vendorStmt.GPVID = this.gpVID;
    if (this.filename) {
      this.spinner.show();
      this.vendorStmt.AttachedFileName = this.filename;
      this.vendorStmt.FileData = this.arrayBufferToBase64(this.fileData);

      this.vendorSvc.submitStatement(this.vendorStmt)
      .takeWhile(() => this.alive)
      .subscribe(
        data => {
          this.spinner.hide();
          this.showFailConfirmation = false;
          this.showSuccessConfirmation = true;
          this.errorMsg = null;
          this.successMsg = 'Your have successfully submitted a statement.';
          console.log(data);
        },
        err => {
          this.spinner.hide();
          this.vendorStmt = null;
          this.showFailConfirmation = true;
          this.showSuccessConfirmation = false;
          this.errorMsg = err;
        }
      );

    } else {
      this.isFileInvalid = true;
      this.fileInputErrorMsg = 'Please uplodad the statement.';
    }
  }

  clearData() {
    this.filename = null;
    this.vendorStmt = new VendorStatement();
    this.showFailConfirmation = false;
    this.showSuccessConfirmation = false;
  }

  readFile(files: FileList) {
    this.reader.onload = e => {
     this.fileData = new Uint8Array(this.reader.result);
    };
    console.log(files[0]);
    this.reader.readAsArrayBuffer(files[0]);
  }

  arrayBufferToBase64(buffer: Uint8Array): string {
    let binary = '';
    const len = buffer.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(buffer[i]);
    }
    return btoa(binary);
  }

  checkFileExt(fileExt: string): boolean {
    // tslint:disable-next-line:max-line-length
    if (!fileExt.match(/.jpg|.jpeg|.bmp|.png|.gif|.tiff|.pdf|.doc|.docx|.xls|.xlsx|.JPG|.JPEG|.BMP|.PNG|.GIF|.TIFF|.PDF|.DOC|.DOCX|.XLS|.XLSX/i)) {
      return false;
    }
    return true;
  }

  async handleFileInput(files: FileList) {
    this.isFileInvalid = false;
    if (files.length !== 1) {
      this.fileInput.nativeElement.value = '';
      return;
    }

    if (files[0].size > 5242880) {
      this.fileInputErrorMsg = "This file's size exceeds the limit";
      this.isFileInvalid = true;
      this.fileInput.nativeElement.value = '';
      return;
    }

    const fileExt = files[0].name.substring(files[0].name.lastIndexOf('.')).toLowerCase();

    if (!this.checkFileExt(fileExt)) {
      console.log('Unsupport this kind of file');
      this.fileInputErrorMsg = "We don't support " + fileExt + " file";
      this.isFileInvalid = true;
      this.fileInput.nativeElement.value = '';
      return;
    }

    this.filename = files[0].name;
    this.readFile(files);
  }

  ngOnDestroy() {
    this.alive = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/vendor/my-vendor/vendor-statement/vendor-statement.component.ts